// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class PrescriptionV1Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param accountId generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    public async accountPrescriptionGet (accountId: string, xTcScopeid?: string, xTcScopetype?: string): Promise<AxiosResponse> {
        const _url_ = '/prescription/v1/AccountPrescription/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPrescriptionGet.');
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param ndcCode generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    public async code (ndcCode?: string, xTcScopeid?: string, xTcScopetype?: string): Promise<AxiosResponse<object>> {
        const _url_ = '/prescription/v1/NdcCode';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (ndcCode !== undefined) {
            _params_['ndcCode'] = Serializer.serialize(ndcCode, "string");
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     * 
     * @param ndcId generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    public async id (ndcId?: string, xTcScopeid?: string, xTcScopetype?: string): Promise<AxiosResponse<object>> {
        const _url_ = '/prescription/v1/NdcId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (ndcId !== undefined) {
            _params_['ndcId'] = Serializer.serialize(ndcId, "string");
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     * 
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async programIdByProgramId (xTcScopeid?: string, xTcScopetype?: string, xProgramId?: number): Promise<AxiosResponse<object>> {
        const _url_ = '/prescription/v1/NdcprogramId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
}
